export interface TrackingProps {
  page_name?: string;
  mode_model_id?: string;
  mode_store_id?: string;
  booking_mode?: string;
  country_code?: string;
  locale_code?: string;
  category_name?: string;
  category_id?: string;
  service_name?: string;
  service_id?: string;
  store_name?: string;
  store_id?: string;
  user_id?: string;
  user_type?: string;
  booking_id?: string;
  booking_type?: string;
  partner?: string;
}

export enum TrackingEvent {
  WIDGET_OPENED = 'onebooking_widget_opened',
  STEP_VIEWED = 'onebooking_step_viewed',
  CATEGORY_SELECTED = 'onebooking_category_selected',
  SERVICE_SELECTED = 'onebooking_service_selected',
  INFO_VALIDATED = 'onebooking_info_validated',
  STORE_SELECTED = 'onebooking_store_selected',
  SLOT_SELECTED = 'onebooking_slot_selected',
  LOGIN_STARTED = 'onebooking_login_started',
  ACCOUNT_IDENTIFIED = 'onebooking_account_identified',
  BOOKING_CONFIRMED = 'onebooking_booking_confirmed',
  BOOKING_CALENDAR_ADDED = 'onebooking_booking_calendar_added',
  BOOKING_RESCHEDULED_CONFIRMED = 'onebooking_booking_rescheduled_confirmed',
  BOOKING_CANCELLATION_CONFIRMED = 'onebooking_booking_cancellation_confirmed',
  REPAIR_WITH_PARTNER_CLICKED = 'onebooking_repair_with_partner_clicked',
  REPAIR_WITH_PARTNER_CH_CLICKED = 'onebooking_repair_with_partner_ch_clicked',
}
